// extracted by mini-css-extract-plugin
export var attribution = "_as-4";
export var authorName = "_as-5";
export var quote = "_as-3";
export var testimonial = "_as-2";
export var trustedBy = "_as-0";
export var trustedByLabel = "_as-1";